import { formatDate } from '@angular/common'
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  OnInit,
} from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { AuthService } from 'src/app/core/services/auth/auth.service'
import { CommonService } from 'src/app/core/services/common/common.service'
import { HttpService } from 'src/app/core/services/http/http.service'
import { LoaderService } from 'src/app/core/services/loader/loader.service'
import { RouterService } from 'src/app/core/services/router/router.service'
import { StorageService } from 'src/app/core/services/storage/storage.service'
import { ApiMethod, Endpoints, ErrorCodes, routePath } from 'src/app/core/services/utils/constants'
import { WepService } from 'src/app/core/services/wep.service'
// import { DashboardComponent } from 'src/app/modules/dashboard/dashboard.component'
import { DataService } from 'src/app/shared/services/data/data.service'
import * as textConfiguration from 'src/assets/branding/text-branding/static-text-configuration.json';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() sideNav: any;
  // @ViewChild('dashboard',{static:false})dashboard:DashboardComponent;
  @Output() istoggle = new EventEmitter();
  showCollapseState: boolean = true;
  showNotificationPopUp: boolean = false;
  showPopup: boolean = false;
  userDetails: any;
  userName:any;
  staticText: any = (textConfiguration as any).default;
  data:any = {};
  entityName: any;
  lastlogin: any;
  lastloginFormatted: any
  constructor (
    private _storage: StorageService,
    private _loader: LoaderService,
    private _http: HttpService,
    public _common: CommonService,
    private dialog: MatDialog,
    private authService: AuthService,
    private dataService:DataService,
    private _router: Router,
    private _routeService: RouterService,
    private _authService: AuthService,
    private wep: WepService
  ) {
  }

  ngOnInit (): void {
    this._common.fetchPermssions();
    this.userDetails = this._storage.getUserDetails();
    console.log('userDetails', this.userDetails);
    this.userName = `${this.userDetails.first_name.charAt(0).toUpperCase()}${this.userDetails.last_name.charAt(0).toUpperCase()}`;
    this.entityName = this.userDetails?.group?.entity?.map((entity:any) => entity.name) || [];
    this.lastlogin = this.userDetails.last_login || ''; 

    if (this.lastlogin) {
      const [datePart, timePart] = this.lastlogin.split(' ');
      const [day, month, year] = datePart.split('-');

      const isoString = `${year}-${month}-${day}T${timePart}`;
      const dateObj = new Date(isoString);

      this.lastloginFormatted = formatDate(dateObj, 'MMM d, y | h:mm a', 'en-US');
    } else {
      this.lastloginFormatted = '';
    }
  }
  sideNavToggle(){
    this.sideNav?.toggle();
    // this.dashboard.chartReRender();
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
    this.dataService.chartRender.next(true)
  }

  @HostListener('mouseleave')
  onMouseOver () {
    this.showPopup = false;
  }

  


  toggleSidenav () {
    this.dialog.ngOnDestroy()
    this.showCollapseState = !this.showCollapseState
    this.istoggle.emit(this.showCollapseState ? 'standard' : 'icon')
  }

  getProfilePhoto() {
    return this.userDetails?.profile_photo || 'assets/images/common/icons/logo_img/default_profile.svg';
  }
  
  logout () {
    this.wep.clearCachedDataForDashboard();
    let isWebsiteUser = this._authService.isWebsiteUser();
    this.authService.logout();    
    //this._router.navigate([isWebsiteUser ? '' : 'portal/auth/login' ]);    
  }
  
  clearLoginSession() {
    this._loader.show();    
    let endpoint: any = `${Endpoints.LOGOUT}`;
    this._http.requestCall(endpoint, ApiMethod.POST, {'refresh': this._storage.geRefreshtToken()}).subscribe((response: any) => {

      if(response?.code == ErrorCodes.HTTP_200_SUCCESS){
        this._loader.hide();
        this.authService.logout();    
      }
    })
  }


  @HostListener('document:click', ['$event'])
  onGlobalClick (event: any): void {
    if (
      !document.getElementById('notification')?.contains(event?.target) &&
      !document.getElementById('notificationBox')?.contains(event?.target)
    ) {
      this.showNotificationPopUp = false
    }
  }

  userProfile(){
    this._routeService.navigatePages(`${routePath?.USER_PROFILE_PATH}`);
  }

}
